module.exports = __webpack_public_path__ + "static/27gde-76ea44cae930ebce6e54d5101edfca0e.gif";